<template>
    <va-edit-layout>
        <SellerReviewEnrollmentPaymentEventFee-form
            :id="id"
            :title="title"
            :item="item"
        ></SellerReviewEnrollmentPaymentEventFee-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
